import goToCategory from '@/navigation/CSR/goToCategory/goToCategory'

import { useRouter } from 'next/navigation'
import { CategoryPathProps } from '~types/index'

const useCategoryCtrls = () => {
  const route = useRouter()

  const onSeeMore = ({ category }: { category: CategoryPathProps }) =>
    goToCategory(route, category)

  return { onSeeMore }
}

export default useCategoryCtrls
